import { Box, CircularProgress } from '@mui/material';

export function PageLoader() {
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60dvh' }} role="status">
      <CircularProgress size={26} />
    </Box>
  );
}
